import { LocalizationState } from '@tsq-web/localization';

export const mockedLocalizationState: LocalizationState = {
  language: 'en',
  timeZone: 'America/Sao_Paulo',
};
